// app/i18n/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    fallbackLng: "en-US",
    lng: "en-US",
    load: "currentOnly",
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});

export default i18n;

// import i18n from "i18next";
// import Backend from 'i18next-http-backend';
// import { initReactI18next } from 'react-i18next';
// import { httpRequestByUrl } from "../../service/http-services/request-backend-api";
// import TranslationUtils from "../../service/translation-utils";

// i18n
//     .use(Backend)
//     .use(initReactI18next)
//     .init({
//         // debug: true, // No debug options when no error :)
//         fallbackLng: 'en-US',
//         lng: 'en-US',
//         load: "currentOnly",
//         backend: {
//             loadPath: '/api/records/sys_translations?conditions=language=\'{{lng}}\'',
//             request: (options: any, url: any, payload: any, callback: any) => {
//                 const tUtils = new TranslationUtils();
//                 httpRequestByUrl(url).then(
//                     (data) => {
//                         callback(null, {
//                             data: tUtils.parseTranslationData(data.data),
//                             status: 200
//                         });
//                     },
//                     (err) => {
//                         callback(err);
//                     }
//                 );
//             },
//             react: {
//                 useSuspense: false
//             }
//         }
//     });

// export default i18n;